import React from 'react';
import LinkCard from '../layout/LinkCard';

const ParametersList = () => {
    //Prefijo
    const routePrefix = 'parametros'
    //Inicializo los parámetros
    const parameters = [
        {
            title: 'Categorías',
            subtitle: 'Audiencias',
            icon: '',
            color: 'primary',
            link: `${routePrefix}/audiencia-categorias`
        },
        {
            title: 'Tipos',
            subtitle: 'Audiencias',
            icon: '',
            color: 'primary',
            link: `${routePrefix}/audiencia-tipos`
        },
        {
            title: 'Motivos Cancelación',
            subtitle: 'Audiencias',
            icon: '',
            color: 'primary',
            link: `${routePrefix}/audiencia-motivos-cancelacion`
        },
        {
            title: 'Tipos',
            subtitle: 'Resultados',
            icon: '',
            color: 'secondary',
            link: `${routePrefix}/resultado-tipos`
        },
        {
            title: 'Modalidades',
            subtitle: 'Resultados',
            icon: '',
            color: 'secondary',
            link: `${routePrefix}/resultado-modalidades`
        },
        {
            title: 'Caracteres',
            subtitle: 'Personas',
            icon: '',
            color: 'danger',
            link: `${routePrefix}/caracteres`
        },
        {
            title: 'Tipo Inhibiciones',
            subtitle: 'Personas',
            icon: '',
            color: 'danger',
            link: `${routePrefix}/persona-inhibicion-tipos`
        },
        {
            title: 'Defensorías',
            subtitle: 'Unidades',
            icon: '',
            color: 'warning',
            link: `${routePrefix}/unidad-defensorias`
        },
        {
            title: 'Dependencias',
            subtitle: 'Unidades',
            icon: '',
            color: 'warning',
            link: `${routePrefix}/unidad-dependencias`
        },
        {
            title: 'Tipo Dependencia',
            subtitle: 'Unidades',
            icon: '',
            color: 'warning',
            link: `${routePrefix}/unidad-dependencia-tipos`
        },
        {
            title: 'Salas',
            subtitle: 'Sistema',
            icon: '',
            color: 'success',
            link: `${routePrefix}/salas`
        },
        /*{
            title: 'Servidores',
            subtitle: 'Sistema',
            icon: '',
            color: 'success',
            link: `${routePrefix}/servidores`
        },*/
        {
            title: 'Tipos',
            subtitle: 'Licencias',
            icon: '',
            color: 'dark',
            link: `${routePrefix}/licencia-tipos`
        }
    ];
    //Renderizo
    return (
        <div className="row">
            {
                parameters.map((p, index) => (
                    <LinkCard 
                        key={`param${index}`}
                        title={p.title} 
                        subtitle={p.subtitle} 
                        icon={p.icon}
                        color={p.color}
                        link={p.link}
                    />
                ))
            }
        </div>
    );
};

export default ParametersList;